<template>
<span class="InfoTypeIcon">

     <span v-if="infoType == 1">
        <b-icon icon="card-text" :scale="iscale" v-b-tooltip.hover :title="$t('infotypeicon.text_info')"/>
        <span v-if="showText">{{ $t('infotypeicon.text_info') }}</span>
    </span>

    <span v-if="infoType == 4">
        <b-icon icon="card-image" variant="info" :scale="iscale" v-b-tooltip.hover :title="$t('infotypeicon.img_info')"/>
        <span v-if="showText">{{ $t('infotypeicon.img_info') }}</span>
    </span>


     <span v-if="infoType == 5">
        <b-icon icon="exclamation-triangle" variant="danger" :scale="iscale" v-b-tooltip.hover :title="$t('infotypeicon.disruption')"/>
        <span v-if="showText">{{ $t('infotypeicon.disruption') }}</span>
    </span>

    <!--
    <span v-if="infoType == 'ext'">
        <b-icon icon="info-square" variant="warning" :scale="iscale" v-b-tooltip.hover :title="$t('infotypeicon.external')"/>
         <span v-if="showText">{{ $t('infotypeicon.text_info') }}</span>
    </span>

    <span v-if="infoType == 'txt'">
        <b-icon icon="card-text" :scale="iscale" v-b-tooltip.hover :title="$t('infotypeicon.text_info')"/>
        <span v-if="showText">{{ $t('infotypeicon.text_info') }}</span>
    </span>

    <span v-if="infoType == 'img'">
        <b-icon icon="card-image" variant="info" :scale="iscale" v-b-tooltip.hover :title="$t('infotypeicon.img_info')"/>
        <span v-if="showText">{{ $t('infotypeicon.img_info') }}</span>
    </span>

    <b-icon v-if="infoType == 'html'" icon="info-square" variant="secondary" :scale="iscale" v-b-tooltip.hover :title="$t('infotypeicon.html_info')"/>

    <span v-if="infoType == '?'">
        <b-icon v-if="infoType == '?'" icon="info-square" variant="danger" :scale="iscale" v-b-tooltip.hover :title="$t('infotypeicon.unknown')"/>
        <span v-if="showText">{{ $t('infotypeicon.unknown') }}</span>
    </span>

    <span v-if="infoType == '?'">
        <b-icon v-if="infoType == '?'" icon="info-square" variant="danger" :scale="iscale" v-b-tooltip.hover :title="$t('infotypeicon.unknown')"/>
        <span v-if="showText">{{ $t('infotypeicon.unknown') }}</span>
    </span>
    -->

</span>
</template>

<script>
export default {
    name:"InfoTypeIcon",
    props: ['info' , 'scale', 'showText'],
    computed: {
        infoType() {
            var type = "?"
            if( this.info ) 
                type = this.info.tyyppi;
            return type;
        },
        old_infoType() {
            var type = "?"
            if( this.info ) {
                if( this.info.externalId )
                    return "ext"
                if( this.info.tyyppi) {
                    if( this.info.tyyppi == 1 )
                        return "txt"
                    if( this.info.tyyppi == 4 )
                        return "img"
                    if( this.info.tyyppi == 6 )
                        return "html"
                }
            }
            return type
        },
        iscale() {
            return this.scale ? this.scale : "1"
        }
    }
}
</script>